import CaseFile from "./CaseFile";

const MEDIA = "/media/projects/wing-pong";

const data = {
    index: "003",
    client: "First We Feast",
    title: "Hot Ones Wing Pong",
    titleLines: ["Hot Ones", "Wing Pong"],
    lead: "Fast. Playful. Competitive.",
    passages: [
        "Hot Ones Wing Pong is a First We Feast series combining the competitive energy of a game show with the recognizable heat and chaos of the Hot Ones brand. Money Mac Media led the creative direction and execution of the motion graphics package — a visual language built to move at the speed of the game.",
        "The direction leaned into competition, heat, impact, and playful tension: graphics energetic enough to add structure and humor, useful enough to support the format, and distinct from the main show without losing the Hot Ones universe.",
    ],
    gallery: [
        {
            label: "Key art & identity",
            items: [
                { src: `${MEDIA}/thumb.webp`, caption: "Show key art — thumbnail", testid: "wingpong-thumb" },
                { src: `${MEDIA}/logo-set.webp`, caption: "Logo set", testid: "wingpong-logo-set" },
            ],
        },
        {
            label: "In-game graphics",
            items: [
                { src: `${MEDIA}/death-cup.webp`, caption: "Death Cup — in-game graphic", testid: "wingpong-death-cup" },
                { src: `${MEDIA}/graphic-mortis.webp`, caption: "Episode graphic — Mortis", testid: "wingpong-mortis" },
            ],
        },
    ],
    contributions: [
        "Motion graphics and show package elements",
        "Visual treatments supporting gameplay and pacing",
        "Score moments, transitions, lower thirds, and episode structure",
        "The show format, translated into a clear visual system",
        "Hot Ones brand recognition with a distinct Wing Pong identity",
        "Graphics built for production and editorial usability",
    ],
    services: [
        "Creative direction",
        "Motion graphics package",
        "Score moments",
        "Transitions",
        "Lower thirds",
        "Episode graphics",
        "Show package",
    ],
};

export default function WingPong() {
    return <CaseFile data={data} />;
}
